import socketIOClient from 'socket.io-client';
import { backendDomain } from '../config';
let socket = null;
export const init = (token) => new Promise((resolve) => {
    socket = socketIOClient(backendDomain);
    socket.emit('init');
    socket.on('init', () => {
        socket.emit('authenticate', { token }); // token: localStorage.getItem('token')
        socket.on('authenticate', () => {
            resolve(socket);
        });
    });
});
